export default "__VITE_ASSET__B2vN0AQT__"